import { cn } from "@/lib/utils";

const MAP = {
  Live: "border-emerald-500/20 bg-emerald-500/10 text-emerald-400",
  Building: "border-blue-500/20 bg-blue-500/10 text-blue-400 animate-pulse",
  Failed: "border-red-500/20 bg-red-500/10 text-red-400",
  Idle: "border-neutral-700 bg-neutral-800/50 text-neutral-400",
};

export function StatusBadge({ status = "Idle", className }) {
  return (
    <span
      data-testid={`status-badge-${status.toLowerCase()}`}
      className={cn(
        "inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-xs font-semibold",
        MAP[status] || MAP.Idle,
        className
      )}
    >
      <span className="h-1.5 w-1.5 rounded-full bg-current" />
      {status}
    </span>
  );
}
